import type { GetStaticPaths, GetStaticProps, NextPage } from "next";
import Head from "next/head";
import { ParsedUrlQuery } from "querystring";
import { BlogList } from "components/molecules/BlogList";
import { BlogPage } from "components/organisms/BlogPage";
import { MDXFrontMatter } from "types";
import { getAllMdx } from "utils/mdx";
import { slugify } from "utils/utils";
interface ContextProps extends ParsedUrlQuery {
  tag: string;
}
interface BlogPostsProps {
  tag: string;
  blogs: Array<MDXFrontMatter>;
}
const BlogPosts: NextPage<BlogPostsProps> = ({
  tag,
  blogs
}) => {
  return <>
            <Head data-sentry-element="Head" data-sentry-source-file="[tag].tsx">
                <title>
                    `CharGen: AI Generated RPG Character Generator Blogs Tagged:
                    ${tag}`
                </title>
                <meta name="description" content={`CharGen Blogs tagged ${tag}: AI Generated Art for your D&D Characters within seconds. Create stunning D&D Characters art for free with CharGen. No prompting or AI knowledge needed!`} data-sentry-element="meta" data-sentry-source-file="[tag].tsx" />
                <meta property="og:url" key="og:url" content={`https://char-gen.com/blogs/tagged/${tag}`} data-sentry-element="meta" data-sentry-source-file="[tag].tsx" />
                <meta property="og:description" key="og:description" content={`CharGen Blogs tagged ${tag}: AI Generated Art for your D&D Characters within seconds. Create stunning D&D Characters art for free with CharGen. No prompting or AI knowledge needed!`} data-sentry-element="meta" data-sentry-source-file="[tag].tsx" />
            </Head>
            <BlogPage title={`Blogs tagged: "${tag}"`} data-sentry-element="BlogPage" data-sentry-source-file="[tag].tsx">
                <BlogList blogs={blogs} data-sentry-element="BlogList" data-sentry-source-file="[tag].tsx" />
            </BlogPage>
        </>;
};
export const getStaticPaths: GetStaticPaths = async () => {
  // Retrieve and filter the MDX files, ensuring only defined frontMatter is processed
  const mdxFiles = getAllMdx().map((blog: {
    frontMatter: MDXFrontMatter;
    content: string;
  } | null) => blog?.frontMatter).filter((frontMatter): frontMatter is MDXFrontMatter => frontMatter !== undefined);

  // Extract unique tags from the filtered frontMatter
  const allTags = new Set(mdxFiles.map(file => file.tags).flat().filter((tag): tag is string => tag !== undefined));

  // Map unique tags to paths
  const paths = Array.from(allTags).map(tag => ({
    params: {
      tag: slugify(tag)
    }
  }));
  return {
    paths,
    fallback: false
  };
};
export const getStaticProps: GetStaticProps = async context => {
  const {
    tag
  } = context.params as ContextProps;
  // Retrieve and filter the MDX files, ensuring only defined frontMatter is processed
  const mdxFiles = getAllMdx().map((blog: {
    frontMatter: MDXFrontMatter;
    content: string;
  } | null) => blog?.frontMatter).filter((frontMatter): frontMatter is MDXFrontMatter => frontMatter !== undefined);

  // Filter blogs by the provided tag
  const filteredBlogs = mdxFiles.filter(file => file.tags?.includes(tag));
  return {
    props: {
      tag,
      blogs: filteredBlogs
    }
  };
};
export default BlogPosts;